import React, { useState, useEffect } from "react";
import {
  FaPenFancy,
  FaPills,
  FaRemoveFormat,
  FaStethoscope,
} from "react-icons/fa";
import { logout } from "../actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import VisitMedicationForm from "./VisitMedicationForm";
import axios from "axios";
import { notify } from "./notify";
import MyLines from "./MyLines";
import { Row, Col, Button, ListGroup, Card } from "react-bootstrap";
import { FaPlusCircle, FaTrashAlt } from "react-icons/fa";
import VisitCheckListSubtitle from "./VisitCheckListSubtitle";
import TextEditor from "./TextEditor";
import { TbListSearch } from "react-icons/tb";
import { AiOutlineSend } from "react-icons/ai";
import Message from "./Message";
import Loader from "./Loader";
import { listTradeLabels } from "../actions/drugActions";
import { consult, transfer } from "../data/nurseForms";
import {
  MdFormatListBulleted,
  MdOutlineTransferWithinAStation,
} from "react-icons/md";

const VisitPhysicianForm = ({ visit, setVisitsVehicle, clinic }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [missedCheckLists, setMissedCheckLists] = useState([]);
  const [referesh, setReferesh] = useState(false);

  const [rosheta, setRosheta] = useState([
    {
      idx: Math.random(),
      tradeLabel: "",
      tradeId: "",
      tradeRootId: "",
      direction: "",
    },
  ]);
  const [physicianNote, setPhysicianNote] = useState("");
  const [newTrades, setNewTrades] = useState([]);
  const [visitCheckLists, setVisitCheckLists] = useState([]);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const tradeLabelsStore = useSelector((state) => state.tradeLabelsStore);
  const { noRequest } = tradeLabelsStore;

  const dispatch = useDispatch();

  if (!localStorage.tradeLabels && noRequest) {
    dispatch(listTradeLabels());
  }
  let tradeLabels =
    localStorage.tradeLabels && JSON.parse(localStorage.tradeLabels);

  const addMedication = () => {
    setRosheta([
      ...rosheta,
      {
        idx: Math.random(),
        tradeLabel: "",
        tradeId: "",
        tradeRootId: "",
        direction: "",
      },
    ]);
  };

  const deleteMedication = (medication) => {
    // console.log(medication);
    if (window.confirm("You will delete this medication. Are you sure?")) {
      if (medication.idx) {
        setRosheta(rosheta.filter((p) => p.idx !== medication.idx));
      } else {
        setRosheta(rosheta.filter((p) => p._id !== medication._id));
      }
    }
  };

  const addPhysicianSection = async () => {
    // update physician note action
    try {
      setLoading(true);

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.post(
        `/api/visits/${visit._id}/addVisitPhysicianSection`,
        {
          visitCheckLists,
          rosheta: rosheta.filter((r) => r.tradeId),
          physicianNote,
        },
        config,
      );

      if (data.message === "ADDED") {
        setVisitsVehicle();
        setLoading(false);
        notify({
          title: "Physician Section Action",
          message: <p className="lead">Data added successfully.</p>,
          type: "success",
          duration: 4000,
        });
      }
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      setError(message);
    }
  };
  const handleClear = () => {
    if (window.confirm("You will delete all text. Are you sure?")) {
      setPhysicianNote("");
    }
  };
  useEffect(() => {
    const trueNewTrades = newTrades.filter((t) => t._id && t.label);
    // console.log("trueNewTrades:", newTrades);

    if (trueNewTrades.length > 0) {
      // merge new trades if found to localStorage tradeLabels
      const clientTradeLabels =
        JSON.parse(localStorage.getItem("tradeLabels")) || [];
      clientTradeLabels.push(...trueNewTrades);
      localStorage.setItem("tradeLabels", JSON.stringify(clientTradeLabels));
      // SOMETHING LIKE REFERESH

      //then clear state
      setNewTrades([]);
    }
  }, [newTrades]);
  useEffect(() => {
    // find missed scan
    if (!visitCheckLists) {
      setMissedCheckLists(
        clinic?.clinicCheckLists.map((cc) => {
          return {
            titleId: cc._id,
            title: cc.title,
          };
        }),
      );
    } else if (visitCheckLists.length < clinic.clinicCheckLists?.length) {
      setMissedCheckLists(
        clinic.clinicCheckLists.filter(
          (s) =>
            !visitCheckLists?.find(
              (ss) => ss.titleId.toString() === s._id.toString(),
            ),
        ),
      );
    } else {
      setMissedCheckLists([]);
    }
  }, [visitCheckLists, clinic, referesh]);
  return (
    <div className="py-3">
      {" "}
      <h4
        className="text-center text-white p-4"
        style={{ backgroundColor: "#14A44D" }}
      >
        {" "}
        <FaStethoscope /> Physician Section
      </h4>
      {/* ========================== PATIENT HISTORY ============================= */}
      {/* COMING SOON */}
      {/* ========================== CheckLists ============================= */}
      <Row className="text-center">
        <h2 className="col">
          {" "}
          <TbListSearch /> Clinical CheckLists
        </h2>
      </Row>
      {/* <pre>{JSON.stringify(clinic.clinicCheckLists, null, 2)}</pre> */}
      <ListGroup className="p-3">
        {visitCheckLists?.map((vs) => {
          const XCheckList = clinic.clinicCheckLists?.find(
            (cc) => cc._id.toString() === vs.titleId.toString(),
          );
          return (
            <>
              <Row className="text-center text-primary">
                <Col className="mb-2">{XCheckList?.title.toUpperCase()}</Col>
                <Col className="text-right">
                  <Button
                    variant="outline-danger"
                    onClick={() => {
                      if (
                        window.confirm(
                          "You will delete this list. Are you sure?",
                        )
                      ) {
                        setVisitCheckLists(
                          visitCheckLists.filter(
                            (vs) =>
                              vs.titleId?.toString() !==
                              XCheckList?._id?.toString(),
                          ),
                        );
                      }
                    }}
                  >
                    <FaTrashAlt />
                  </Button>
                </Col>
              </Row>
              {vs.subtitles.map((st) => {
                const XSubtitle = XCheckList?.subtitles.find(
                  (sct) => sct._id === st.subtitleId,
                );
                return (
                  <div key={st._id || st.idx}>
                    {st.subtitleId && (
                      <Row className="px-3 my-2">
                        <Col className="bg-secondary text-white col align-self-center p-2">
                          {XSubtitle?.subtitle}
                        </Col>
                        <Col>
                          {/* <pre>{JSON.stringify(st, null, 2)}</pre> */}
                          <VisitCheckListSubtitle
                            titleId={XCheckList?.titleId}
                            options={XSubtitle?.options}
                            subtitle={st}
                            referesh={referesh}
                            setReferesh={setReferesh}
                          />
                        </Col>
                      </Row>
                    )}
                  </div>
                );
              })}
            </>
          );
        })}
      </ListGroup>
      {/* {missedCheckLists?.map((ms, order) => (
        <Button
          key={order}
          className="btn-secondary w-100 my-2"
          onClick={() =>
            setVisitCheckLists((prev) => [
              ...prev,
              {
                idx: Math.random(),
                titleId: ms._id,
                subtitles: ms.subtitles.map((st) => ({
                  idx: Math.random(),
                  subtitleId: st._id,
                  selectedOptionId:
                    st.options.filter((o) => !o.isHide)[0]?._id || "", //make first option as default
                  selectedOption:
                    st.options.filter((o) => !o.isHide)[0]?.label || "",
                })),
              },
            ])
          }
        >
          {" "}
          <FaPlusCircle /> {` ${ms.title}`}
        </Button>
      ))} */}
      {missedCheckLists?.map((ms, order) => {
        const currentFirstTwo = ms.title?.split(" ").slice(0, 2).join(" ");
        const previousFirstTwo = missedCheckLists[order - 1]?.title
          ?.split(" ")
          .slice(0, 2)
          .join(" ");

        const showLine = order === 0 || currentFirstTwo !== previousFirstTwo;

        return (
          <div key={order}>
            {showLine && (
              <div className="d-flex align-items-center my-2">
                <hr className="flex-grow-1" />
                <span className="mx-3 fw-bold">{currentFirstTwo}</span>
                <hr className="flex-grow-1" />
              </div>
            )}

            <Button
              className="btn-secondary w-100 my-2"
              onClick={() =>
                setVisitCheckLists((prev) => [
                  ...prev,
                  {
                    idx: Math.random(),
                    titleId: ms._id,
                    subtitles: ms.subtitles.map((st) => ({
                      idx: Math.random(),
                      subtitleId: st._id,
                      selectedOptionId:
                        st.options.filter((o) => !o.isHide)[0]?._id || "",
                      selectedOption:
                        st.options.filter((o) => !o.isHide)[0]?.label || "",
                    })),
                  },
                ])
              }
            >
              <FaPlusCircle /> {ms.title}
            </Button>
          </div>
        );
      })}
      <MyLines type="dashed" />
      {/* ========================== MEDICATIONS ============================= */}
      <Row className="text-center">
        <h2 className="col">
          {" "}
          <FaPills /> Medications
        </h2>
      </Row>
      <div className="py-2">
        {rosheta.map((m) => (
          <VisitMedicationForm
            key={m._id || m.idx}
            tradeLabels={tradeLabels}
            medication={m}
            deleteMedication={deleteMedication}
            rosheta={rosheta}
          />
        ))}

        <Row className="justify-content-center">
          <Col className="text-center">
            <Button
              className="btn btn-secondary btn-block my-3"
              onClick={() => addMedication()}
            >
              <FaPlusCircle className="me-2" /> Click to Add Another Medication
            </Button>
          </Col>{" "}
        </Row>
        <MyLines type="dashed" />
        {/* ========================== Note ============================= */}
        <Row className="text-center">
          <h2 className="col">
            {" "}
            <FaPenFancy /> Notes | Forms
          </h2>
        </Row>
        <TextEditor text={physicianNote} setText={setPhysicianNote} />
        <Row className="g-3 text-center text-primary my-2">
          <Col
            className="my-2"
            md={3}
            onClick={() => setPhysicianNote((prev) => prev + consult)}
          >
            <Card className="h-100 shadow-sm border border-primary">
              <Card.Body>
                <Card.Text>
                  <MdFormatListBulleted /> Add Consultation Form{" "}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col
            className="my-2"
            md={3}
            onClick={() => setPhysicianNote((prev) => prev + transfer)}
          >
            <Card className="h-100 shadow-sm border border-primary ">
              <Card.Body>
                <Card.Text>
                  <MdOutlineTransferWithinAStation /> Add Transfer Form{" "}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col className="my-2" md={3} onClick={handleClear}>
            <Card className="h-100 shadow-sm border border-danger text-danger">
              <Card.Body>
                <Card.Text>
                  <FaRemoveFormat /> Clear{" "}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {/* ========================== SUBMIT ============================= */}
        {error && (
          <Message
            children={`Add Physician Section Err: ${error}`}
            variant={`danger`}
            setMessage={setError}
          />
        )}
        {loading ? (
          <Loader />
        ) : (
          <Row className="w-100 justify-content-end my-2">
            <Col className="mr-2 col-auto">
              <Button
                variant="outline-success"
                onClick={() => addPhysicianSection()}
              >
                <AiOutlineSend /> Add Physician Section
              </Button>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};

export default VisitPhysicianForm;
